import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { GenericSubSection } from '../common/GenericSubSection';
import { useExteriorGeneralSection } from '../../hooks/useExteriorGeneralSection';
import { useExteriorVideo } from '../../hooks/useExteriorVideo';

export const ExteriorLevel3 = () => {
  const { section, images } = useExteriorGeneralSection();
  const video = useExteriorVideo();

  return (
    <Level2Wrapper flex="1 1 100%" label="Exterior">
      <ImageList video={video} label="Exterior Pictures" images={images} />
      {Object.values(section?.subsections ?? {}).map(sub => (
        <GenericSubSection key={sub.id} section={sub} />
      ))}
    </Level2Wrapper>
  );
};
